import { css } from '@linaria/core';
import Spinner from '../../atoms/Spinner';
const styles = css `
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  gap: 4px;
`;
export function ButtonLoader({ loadingComponent }) {
    return <div className={styles}>{loadingComponent || <Spinner />}</div>;
}
ButtonLoader.defaultProps = {
    loadingComponent: undefined,
};
